import React, { useRef, useEffect } from 'react';
import './HeroSection.css';
import heroImage from '../assets/images/deity-balaji-new.png';

function HeroSection() {
  const contentRef = useRef(null);

  useEffect(() => {
    // Add scroll animation on mount
    if (contentRef.current) {
      contentRef.current.classList.add('animate-in');
    }
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-container">
        {/* Image Section - Left Side */}
        <div className="hero-video-wrapper">
          <img
            src={heroImage}
            alt="Lord Lakshmi Venkateswara"
            className="hero-video"
          />
          <div className="video-overlay"></div>
        </div>

        {/* Content Section - Right Side */}
        <div className="hero-content-wrapper" ref={contentRef}>
          <div className="hero-content">
            <span className="hero-label">Welcome to</span>
            <h1 className="hero-title">
              <span className="title-line-1">GPR Grande</span>
              <span className="title-line-2">Sri Lakshmi Venkateswara Temple</span>
            </h1>
            
            <p className="hero-description">
              Experience the divine presence of Lord Lakshmi Venkateswara at our 
              sacred temple in Chandapura, Bangalore. Our temple stands as a beacon of 
              faith, devotion, and spiritual enlightenment, welcoming devotees 
              seeking blessings and inner peace.
            </p>

            <p className="hero-description-secondary">
              Join us in this sacred journey and discover the profound spiritual 
              heritage. The temple trust was registered on 2nd August 2025, 
              continuing the tradition of devotion and service.
            </p>

            <div className="hero-cta">
              <a href="#darshan" className="btn btn-primary">
                <span>Book Darshan</span>
                <i className="fas fa-arrow-right"></i>
              </a>
              <a href="#about-temple" className="btn btn-secondary">
                <span>Learn More</span>
                <i className="fas fa-info-circle"></i>
              </a>
            </div>

            <div className="hero-scroll-indicator">
              <div className="scroll-line"></div>
              <span>Scroll to explore</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
